export default __webpack_public_path__ + "static/media/PlungerLift.3003dec2.png";